document.addEventListener('DOMContentLoaded', () => {
	initTabs();
	initModal();
	initHeroSlider();
	initNewsSlider();
	initCatalogSlider();
	initProductSlider();
	// initCatalogMenu();
	initBurger();
	initGlobalSearch();
	initCalc();
	sendContactsForm();
});

function initHeroSlider() {
	new Swiper('.js-hero-slider', {
		speed: 300,
		navigation: {
			nextEl: '.js-hero-button-next',
			prevEl: '.js-hero-button-prev',
		},
		loop: true,
	});
}

function initNewsSlider() {
	const controls = document.querySelector('.news__swiper-controls');
	const slider = document.querySelector('.js-news-slider');
	
	if (!slider) {
		return;
	}
	
	const items = slider.querySelectorAll('.swiper-slide');
	const windowWidth = window.innerWidth;
	const amount = 3;
	
	if (windowWidth <= 640) {
		controls.classList.remove('is-hidden');
	} else {
		if (items.length > amount) {
			controls.classList.remove('is-hidden');
		}
	}
	
	const swiper = new Swiper(slider, {
		speed: 300,
		navigation: {
			nextEl: '.js-news-button-next',
			prevEl: '.js-news-button-prev',
		},
		pagination: {
			el: '.js-news-pagination',
			type: 'bullets',
		},
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			641: {
				slidesPerView: 3
			}
		},
		loop: true,
	});
}

function initCatalogSlider() {
	const controls = document.querySelector('.slider-catalog__swiper-controls');
	const slider = document.querySelector('.js-catalog-slider');
	
	if (!slider) {
		return;
	}
	
	const items = slider.querySelectorAll('.swiper-slide');
	const windowWidth = window.innerWidth;
	const amount = 4;
	
	if (windowWidth <= 640) {
		controls.classList.remove('is-hidden');
	} else {
		if (items.length > amount) {
			controls.classList.remove('is-hidden');
		}
	}
	
	const swiper = new Swiper(slider, {
		speed: 300,
		navigation: {
			nextEl: '.js-catalog-slider-button-next',
			prevEl: '.js-catalog-slider-button-prev',
		},
		pagination: {
			el: '.js-catalog-pagination',
			type: 'bullets',
		},
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			641: {
				slidesPerView: amount
			}
		},
		loop: true,
	});
}

function initProductSlider() {
	const speed = 300;
	const activeClass = 'is-active';
	const swiper = new Swiper('.js-product-slider', {
		speed: speed,
		slidesPerView: 1,
		navigation: {
			nextEl: '.js-product-slider-button-next',
			prevEl: '.js-product-slider-button-prev',
		},
		pagination: {
			el: '.js-product-slider-pagination',
			type: 'bullets',
		},
		loop: true,
	});
}

const initTabs = () => {
	const links = document.querySelectorAll('.product__tabs-link');
	const tabItems = document.querySelectorAll('.product__tabs-content-item');
	
	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			
			const id = e.target.getAttribute('id');
			const content = document.querySelector(`[data-id="${id}"]`);
			
			links.forEach((el) => {
				el.classList.remove('is-active');
			});
			
			tabItems.forEach((el) => {
				el.classList.remove('is-active');
			});
			
			link.classList.add('is-active');
			content.classList.add('is-active');
		});
	});
};

const initCatalogMenu = () => {
	const links = document.querySelectorAll('.catalog__menu-link');
	const subLinks = document.querySelectorAll('.catalog__submenu-link');
	
	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			
			const isActiveLink = link.parentElement.classList.contains('is-active');
			
			links.forEach((el) => {
				el.parentElement.classList.remove('is-active');
			});
			
			if (!isActiveLink) {
				link.parentElement.classList.add('is-active');
			}
		});
	});
	
	subLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			
			subLinks.forEach((el) => {
				el.parentElement.classList.remove('is-active');
			});
			
			link.parentElement.classList.add('is-active');
		});
	});
}

const initModal = () => {
	const body = document.querySelector('body');
	const modal = document.querySelector('.js-modal');
	const modalOverlay = document.querySelector('.js-modal-overlay');
	const buttons = document.querySelectorAll('.js-open-modal');
	const closeModal = document.querySelector('.js-close-modal');
	const content = modal.querySelector('.modal__content');
	const loader = modal.querySelector('.js-modal-loader');
	const modalContainer = modal.querySelector('.modal__container');
	const windowWidth = window.innerWidth;
	
	buttons.forEach((button) => {
		button.addEventListener('click', () => {
			const postId = button.dataset.postId;
			
			if (windowWidth <= 640) {
				body.classList.add('is-blocked');
			}
			
			modal.classList.add('is-opened');
			modalOverlay.classList.add('is-opened');
			loader.classList.add('is-active');
			
			if (typeof postId !== 'undefined') {
				fetch(`${window.config.ajax_url}?action=get_product_modal&post_id=${postId}`)
					.then(response => response.json())
					.then(data => {
						if (data.success) {
							loader.classList.remove('is-active');
							content.innerHTML = data.data;
							
							sendProductForm();
						}
					})
					.catch(error => {
						console.error('Error:', error);
					});
			} else {
				console.warn('postId is not defined');
			}
		});
	});
	
	closeModal.addEventListener('click', () => {
		modalContainer.style.display = '';
		modalContainer.style.alignItems = '';
		modalContainer.style.justifyContent = '';
		
		if (windowWidth <= 640) {
			body.classList.remove('is-blocked');
		}
		
		modal.classList.remove('is-opened');
		modalOverlay.classList.remove('is-opened');
		content.innerHTML = '';
	});
};

const initBurger = () => {
	const body = document.querySelector('body');
	const burger = document.querySelector('.js-burger');
	const mobileMenu = document.querySelector('.js-mobile-menu');
	const globalSearch = document.querySelector('.js-global-search');
	const mobileSearchButton = document.querySelector('.js-mobile-search-button');
	
	burger.addEventListener('click', () => {
		if (burger.classList.contains('is-active')) {
			burger.classList.remove('is-active');
			body.classList.remove('is-blocked');
			mobileMenu.classList.remove('is-active');
		} else {
			burger.classList.add('is-active');
			body.classList.add('is-blocked');
			mobileMenu.classList.add('is-active');
			globalSearch.classList.remove('is-active');
			mobileSearchButton.classList.remove('is-active');
		}
	});
}

const stripUnit = (value) => {
	return parseFloat(value) || null;
}

const pxToVw = (value, size) => {
	const valuePx = stripUnit(value);
	const sizePx = stripUnit(size);
	
	return (valuePx / sizePx) * 100 + 'vw';
}

const initGlobalSearch = () => {
	const body = document.querySelector('body');
	const searchInput = document.querySelector('.js-search-input');
	const globalSearch = document.querySelector('.js-global-search');
	const globalSearchContainer = globalSearch.querySelector('.js-global-search-container');
	const innerSearchInput = globalSearch.querySelector('.js-search-inner-input');
	const overlay = globalSearch.querySelector('.js-global-search-overlay');
	const searchCleaner = document.querySelectorAll('.js-search-cleaner');
	const mobileSearchButton = document.querySelector('.js-mobile-search-button');
	const burger = document.querySelector('.js-burger');
	const mobileMenu = document.querySelector('.js-mobile-menu');
	const items = document.querySelector('.global-search__items');
	const total = document.querySelector('.global-search__total span');
	const loader = globalSearch.querySelector('.js-search-loader');
	const tip = globalSearch.querySelector('.global-search__tip');
	
	const debouncedFetch = _.debounce((value) => {
		if (value.trim().length === 0) {
			return;
		}
		
		loader.classList.add('is-active');
		tip.classList.remove('is-active');
		
		fetch(`${window.config.ajax_url}?action=get_catalog_items&s=${encodeURIComponent(value)}`)
			.then(response => response.json())
			.then(data => {
				loader.classList.remove('is-active');
				
				if (data.success) {
					const _items = data.data.items;
					
					if (!_items) {
						tip.classList.add('is-active');
						tip.textContent = 'Ничего не найдено';
					} else {
						tip.classList.remove('is-active');
						tip.textContent = 'Что вы хотите найти?';
					}
					
					items.innerHTML = _items;
					total.textContent = items ? _items.split('global-search__item').length - 1 : '0';
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	}, 500);
	
	if (searchInput) {
		searchInput.addEventListener('focus', () => {
			const windowWidth = window.innerWidth;
			
			globalSearch.classList.add('is-active');
			innerSearchInput.focus();
			
			if (windowWidth <= 640) {
				body.classList.add('is-blocked');
				mobileSearchButton.classList.add('is-active');
				
				return;
			}
			
			const topPosition = searchInput.getBoundingClientRect().top;
			const totalTopOffset = window.scrollY + topPosition;
			
			if (windowWidth >= 1200) {
				globalSearchContainer.style.top = `${totalTopOffset}px`;
			} else {
				globalSearchContainer.style.top = pxToVw(totalTopOffset, window.innerWidth);
			}
		});
	}
	
	
	innerSearchInput.addEventListener('input', (e) => {
		const value = e.target.value;
		
		searchCleaner.forEach((item) => {
			item.classList.toggle('is-active', value.trim().length > 0);
		});
		
		if (searchInput) {
			searchInput.value = value;
			
			debouncedFetch(value);
		}
	});
	
	overlay.addEventListener('click', () => {
		globalSearchContainer.style.top = '';
		globalSearch.classList.remove('is-active');
	});
	
	searchCleaner.forEach((item) => {
		item.addEventListener('click', () => {
			if (searchInput) {
				searchInput.value = '';
			}
			
			innerSearchInput.value = '';
			items.innerHTML = '';
			total.textContent = '0';
			tip.classList.add('is-active');
			tip.textContent = 'Что вы хотите найти?';
			
			searchCleaner.forEach((item) => {
				item.classList.remove('is-active');
				globalSearch.classList.remove('is-active');
				body.classList.remove('is-blocked');
				mobileSearchButton.classList.remove('is-active');
			});
		})
	});
	
	mobileSearchButton.addEventListener('click', () => {
		if (!mobileSearchButton.classList.contains('is-active')) {
			mobileSearchButton.classList.add('is-active');
			body.classList.add('is-blocked');
			globalSearch.classList.add('is-active');
			burger.classList.remove('is-active');
			mobileMenu.classList.remove('is-active');
			innerSearchInput.focus();
		} else {
			mobileSearchButton.classList.remove('is-active');
			body.classList.remove('is-blocked');
			globalSearch.classList.remove('is-active');
		}
	});
}

const initCalc = () => {
	const formCalc = document.querySelector('.js-form-calc');
	
	if (!formCalc) {
		return;
	}
	
	formCalc.addEventListener('submit', async (e) => {
		e.preventDefault();
		
		const formData = new FormData(formCalc);
		const table = document.querySelector('.js-calc-total-table');
		const loader = document.querySelector('.js-calc-loader');
		const formWrapper = document.querySelector('.js-form-wrapper');
		
		table.classList.add('is-hidden');
		loader.classList.add('is-active');
		formWrapper.classList.add('is-loading');
		
		await fetch(`${window.config.ajax_url}?action=send_calc`, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then(data => {
				loader.classList.remove('is-active');
				table.classList.remove('is-hidden');
				formWrapper.classList.remove('is-loading');
				
				table.innerHTML = data.data;
			})
			.catch(error => {
				console.error('Error:', error);
			});
	});
}

const sendProductForm = () => {
	const form = document.querySelector('.js-product-form');
	
	form.addEventListener('submit', async (e) => {
		e.preventDefault();
		
		const modal = document.querySelector('.js-modal')
		const modalContainer = modal.querySelector('.modal__container');
		const content = modal.querySelector('.modal__content');
		const loader = modal.querySelector('.js-modal-loader');
		
		const formData = new FormData(form);
		
		content.innerHTML = '';
		loader.classList.add('is-active');
		
		await fetch(`${window.config.ajax_url}?action=send_product_email`, {
			method: 'POST',
			body: formData,
		})
			.then(response => response.json())
			.then(data => {
				modalContainer.style.display = 'flex';
				modalContainer.style.alignItems = 'center';
				modalContainer.style.justifyContent = 'center';
				
				loader.classList.remove('is-active');
				
				if (data.success) {
					content.innerHTML = `
						<div class="headline headline--medium headline--center headline--m0">Форма успешно отправлена.<br> Менеджер свяжется с вами.</div>
					`;
				} else {
					content.innerHTML = `
						<div class="headline headline--medium headline--center headline--m0">Кажется что-то пошло не так! Попробуйте позже.</div>
					`;
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	});
}

const sendContactsForm = () => {
	const parentFormElement = document.querySelector('.form');
	
	if (parentFormElement) {
		const form = document.querySelector('.js-contacts-form');
		const loader = parentFormElement.querySelector('.js-form-loader');
		
		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			
			const formData = new FormData(form);
			
			form.remove();
			loader.classList.add('is-active');
			
			await fetch(`${window.config.ajax_url}?action=send_contacts_email`, {
				method: 'POST',
				body: formData,
			})
				.then(response => response.json())
				.then(data => {
					loader.classList.remove('is-active');
					
					if (data.success) {
						parentFormElement.innerHTML = `
						<div class="headline headline--small headline--center headline--m0">Форма успешно отправлена.<br> Менеджер свяжется с вами.</div>
					`;
					} else {
						parentFormElement.innerHTML = `
						<div class="headline headline--small headline--center headline--m0">Кажется что-то пошло не так! Попробуйте позже.</div>
					`;
					}
				})
				.catch(error => {
					console.error('Error:', error);
				});
		});
	}
}